import axiosInstance from '../axiosInterceptor/axiosInstance'

const getEventTypes = async (orgId) => {
  const url = `v1/orgs/${orgId}/events/types`
  const response = await axiosInstance.get(url)
  return response?.data
}

export default getEventTypes
